import React from 'react';

interface PaginationProps {
  currentPage: number;
  totalArticles: number;
  articlesPerPage: number;
  isMobile?: boolean;
  onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalArticles,
  articlesPerPage,
  onPageChange,
  isMobile
}) => {
  const totalPages = Math.ceil(totalArticles / articlesPerPage);
  const handlePageChange = (page: number) => {
    const header = document.querySelector('.page-header-section') as HTMLElement | null;
    const offset = header ? header.offsetHeight : 0;
    window.scrollTo({ top: offset, behavior: 'smooth' });
    onPageChange(page);
  };

  const getPaginationElements = () => {
    const elements: (number | string)[] = [];
    const totalPages = Math.ceil(totalArticles / articlesPerPage);

    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) {
        elements.push(i);
      }
    } else {
      if (currentPage <= 2) {
        // 1 2 3 ...
        elements.push(1, 2, 3, '...');
      } else if (currentPage >= totalPages - 1) {
        // ... n-2 n-1 n
        elements.push('...', totalPages - 2, totalPages - 1, totalPages);
      } else {
        // ... c c+1 ...
        elements.push('...', currentPage, currentPage + 1, '...');
      }
    }
    return elements;
  };

  if (totalPages <= 1) return null;

  return (
    <div className="flex items-cente w-full">
        <button
        onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="button button-secondary !px-4 mr-auto"
        aria-label="Previous page"
        style={isMobile ? { borderRadius: 5, width: '40px' } : undefined}
      >
        {isMobile ? <span className="icon icon-left-arrow-alt text-[24px]"> </span> : <span> Back </span>}
      </button>

      {getPaginationElements().map((el, idx) =>
        typeof el === 'number' ? (
          <button
            key={el}
            onClick={() => handlePageChange(el)}
            className={[
              isMobile
                ? "rounded-[4px] px-3"
                : "rounded-[100px] px-3 w-[54px] h-[40px]",
              currentPage === el
                ? (isMobile ? "border border-black" : "border border-black px-[24px]")
                : (!isMobile ? "px-4" : "")
            ].join(' ')}
          >
            <span className={isMobile ? 'b3' : 'h8'}>{el}</span>
          </button>
        ) : (
          <span key={`ellipsis-${idx}`} className="px-1 items-center flex">...</span>
        )
      )}

      <button
        onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="button button-secondary !px-4 ml-auto "
        aria-label="Next page"
        style={isMobile ? { borderRadius: 5, width: '40px' } : undefined}
      >
        {isMobile ?  <span className="icon icon-right-arrow-alt text-[24px]"> </span> : <span> Next </span> }
      </button>
    </div>
  );
};

export default Pagination;
